module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/photo-partner-973485dcb9e70de8abde5fc2a06d1b2a.jpg";